import {
  Loadable,
  Model,
  ModelAttributes,
  ModelDescription,
  model,
  modelConfig,
  reference,
} from "@mixitone/oom";
import TournamentCompetition from "./TournamentCompetition";
import TournamentCompetitionEvent from "./TournamentCompetitionEvent";
import { setAccountId } from "./concerns/SetAccountId";

const config = modelConfig(
  {
    account_id: {
      type: "string",
    },
    club_id: {
      type: "string",
    },
    created_at: {
      type: "datetime",
    },
    is_deleted: {
      type: "boolean",
    },
    last_event_id: {
      type: "string",
    },
    state_blob: {
      type: "json",
      jsonType: {} as Record<string, any>,
    },
    tournament_competition_id: {
      type: "string",
    },
    updated_at: {
      type: "datetime",
    },
  },
  {},
  {
    competition: reference(() => TournamentCompetition as any, "tournament_competition_id"),
    lastEvent: reference(() => TournamentCompetitionEvent as any, "last_event_id"),
  },
);

interface TournamentCompetitionStateSnapshot extends ModelAttributes<typeof config> {
  competition: Loadable<TournamentCompetition>;
  lastEvent: Loadable<TournamentCompetitionEvent>;
}

@setAccountId
@model("tournament_competition_state_snapshots", config)
class TournamentCompetitionStateSnapshot extends Model<typeof config> {
  static readonly modelDescription: ModelDescription = {
    description:
      "Checkpointed reducer snapshot for tournament competition events, used to speed up state replay.",
    availableFields: [...Object.keys(config.fields)],
    relationships: {
      competition: "tournament_competitions where id equals this tournament_competition_id",
      lastEvent: "tournament_competition_events where id equals this last_event_id",
    },
  };
}

export default TournamentCompetitionStateSnapshot;
